const YOUTUBE_VIDEO_ID_RE =
  /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;

/** Prefer youtube-nocookie.com so embeds avoid youtube.com third-party cookies where possible. */
export function toYouTubeNoCookieEmbedSrc(src: string | null | undefined): string {
  if (src == null || typeof src !== "string") return "";
  const s = src.trim();
  if (!s) return "";
  return s
    .replace(/https:\/\/www\.youtube\.com\/embed\//gi, "https://www.youtube-nocookie.com/embed/")
    .replace(/https:\/\/youtube\.com\/embed\//gi, "https://www.youtube-nocookie.com/embed/")
    .replace(/http:\/\/www\.youtube\.com\/embed\//gi, "https://www.youtube-nocookie.com/embed/")
    .replace(/http:\/\/youtube\.com\/embed\//gi, "https://www.youtube-nocookie.com/embed/");
}

export function extractYoutubeVideoId(url: string): string | null {
  const t = url.trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(t)) return t;
  const m = t.match(YOUTUBE_VIDEO_ID_RE);
  return m?.[1] ?? null;
}
